import type { SxProps, Theme } from '@mui/material'

/**
 * The card header both details pages share. The heading carries an evidence
 * step strip as wide as the inspection's flow, so the heading and the action
 * buttons do not always fit on one row: the header wraps, dropping the actions
 * under the heading, right aligned, and the actions wrap among themselves when
 * they do not fit a row either. The gaps keep the actions clear of the heading
 * on whichever row they sit. The heading itself wraps too, in each page, so
 * the strip drops under the container number when the two do not fit a row.
 */
export const detailsHeaderSx = (theme: Theme): SxProps<Theme> => ({
  p: theme.spacing(2, 3),
  bgcolor: theme.palette.background.paper,
  borderBottom: `1px solid ${theme.palette.divider}`,
  flexWrap: 'wrap',
  columnGap: 2,
  rowGap: 1,
  '& .MuiCardHeader-action': {
    // MUI pulls the action slot past the header padding with negative margins,
    // which would put the last button outside the header's content box.
    m: 0,
    ml: 'auto',
    maxWidth: '100%',
  },
})
